import React, { Component }  from 'react';
import { withRouter } from 'react-router';
import moment from 'moment';

class Footer extends Component {
  
  render() {
    return (
      <div>    
        
                    
      <p style={{textAlign:'center'}}>Copyright © {moment().format('YYYY')} American Collective LP. All rights reserved.</p>
                  
      </div>

    )
  }


}
export default withRouter(Footer);